module.exports = __webpack_public_path__ + "static/windlicht-bunt.5d9dd407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/windlicht-bunt.jpg
// module id = 553
// module chunks = 35783957827783